<template>
	<!--注册页面-->
	<div>
		<div class="regisCon">
			<p><input type="text" class="regPho" placeholder="输入您的手机号" v-model="username" maxlength="11"/></p>
			<p>
				<input type="text" class="regPsw" placeholder="密码" v-model="password" maxlength="11"/>
			</p>
			<p>
				<input type="text" class="regNick" placeholder="昵称" v-model="nickname" maxlength="12"/>
			</p>
			<p class="clearfix">
				<input type="text" class="regCode fl" placeholder="验证码" v-model="verificationCode" maxlength="8"/>
				<button v-show="timeShow" class="fr reggetCode" @click="getCode">获取验证码</button>
				<button v-show="!timeShow" class="fr reggetCode">{{timeCount}}秒后重试</button>
			</p>
		</div>
		<div class="regBtn" @click="regBtn">注册</div>
		<div class="regWran">
			<router-link to="/login">已有账号，去登录>></router-link>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import qs from "qs";
// 登录正则
var regphone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
var regPsw = /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{6,12}$/;
export default {
  name: "register",
  data() {
    return {
      username: "",
      password: "",
      nickname: "",
      verificationCode: "",
      pswType: "password",
      timeShow: true,
      timeCount: "",
      timer: null
    };
  },
  methods: {
    // 获取验证码
    getCode: function () {
      if (!regphone.test(this.username)) {
        this.Toast({
          message: "请输入正确的手机号",
          position: "center",
          duration: 1000
        });
        return false;
      } else {
        this.Toast({
          message: "验证码获取成功",
          position: "center",
          duration: 1000
        });
        // 验证码倒计时
        let wait = 59;
        if (!this.timer) {
          this.timeCount = wait;
          this.timeShow = false;
          this.timer = setInterval(() => {
            if (this.timeCount > 1 && this.timeCount <= 60) {
              this.timeCount--;
            } else {
              this.timeShow = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        // ajax
        axios
          .post(
            "/wap/user/createSmsCode",
            qs.stringify({
              phone: this.username
            })
          )
          .then(data => {
            console.log(data.data);
          })
          ["catch"](error => {
            console.log(error);
          });
      }
    },
    // 注册
    regBtn: function () {
      if (!regphone.test(this.username)) {
        this.Toast({
          message: "请输入正确的手机号",
          position: "center",
          duration: 1000
        });
        return false;
      } else if (!regPsw.test(this.password)) {
        this.Toast({
          message: "密码由6-12位数字或字母组成",
          position: "center",
          duration: 2000
        });
        return false;
      } else {
        axios
          .post(
            "/wap/user/register ",
            qs.stringify({
              username: this.username,
              password: this.password,
              nickname: this.nickname,
              verificationCode: this.verificationCode
            })
          )
          .then(data => {
            console.log(data);
            if (data.data.code == 200) {
              	this.$router.push({path:"/login"});
            } else {
              this.Toast({
                message: data.data.msg,
                position: "center",
                duration: 1000
              });
            }
          })
          ["catch"](error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.mint-header {
  height: 88px;
  line-height: 88px;
  background-color: #f6f7f8;
  border-bottom: 1PX solid #e1e1e1;
  color: #333;
  font-size: 36px;
  padding: 0 30px;
  /deep/ h1 {
    font-weight: bold;
  }
}
.mint-button /deep/ i {
  font-size: 36px;
  font-weight: bold;
}
.regisCon p {
  width: 90%;
  margin: 0 auto;
  input,
  .reggetCode {
    margin-top: 44px;
    width: 100%;
    height: 80px;
    /*line-height: 80px;*/
    text-indent: 70px;
		font-size: 26px;
    background: url(../assets/regPho.png) no-repeat 30px center;
    background-size: 30px 30px;
    border: 1PX solid #e1e1e1;
    border-radius: 40px;
  }
  .regPsw {
    background: url(../assets/userPsw.png) no-repeat 20px center;
    background-size: 40px 40px;
  }
  .regNick {
    background: url(../assets/regnick.png) no-repeat 20px center;
    background-size: 30px 30px;
  }
  .regCode {
    width: 60%;
    background: url(../assets/code.png) no-repeat 20px center;
    background-size: 40px 40px;
  }
  .reggetCode {
    width: 34%;
    background: none;
    text-align: center;
    text-indent: 0;
    font-size: 26px;
    color: #ff7f02;
    border-color: #ff7f02;
  }
}
.regBtn {
  width: 90%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fff;
  margin: 100px auto 38px;
  font-size: 32px;
  border-radius: 40px;
  background: url(../assets/loginBg.png) no-repeat center center;
}
.regWran {
  text-align: center;
  color: #666;
  font-size: 26px;
}
</style>
